import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Succès/Échec";
const DESCRIPTION =
  "Calculatrice Succès/Échec pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "succès/échec, calculatrice succès/échec, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/success-failure";
function SuccessFailureCalculator() {
  const [successes, setSuccesses] = useState("");
  const [failures, setFailures] = useState("");
  const [result, setResult] = useState({});
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const succ = parseFloat(successes);
      const fail = parseFloat(failures);
      if (isNaN(succ) || isNaN(fail)) {
        setError("Entrez les valeurs correctes");
        setResult({});
        return;
      }
      const total = succ + fail;
      const successRate = ((succ / total) * 100).toFixed(2);
      const failureRate = ((fail / total) * 100).toFixed(2);
      setResult({ successRate, failureRate, total });
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Succès:</label>
                    <input
                      type="number"
                      value={successes}
                      onChange={(e) => setSuccesses(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Échecs:</label>
                    <input
                      type="number"
                      value={failures}
                      onChange={(e) => setFailures(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {Object.keys(result).length > 0 && (
                  <div>
                    <p className="p-3 mb-2 bg-success text-white">
                      Total: {result.total}
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      Taux de succès: {result.successRate}%
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      Taux d'échec: {result.failureRate}%
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice du taux de réussite et d'échec</h3>
                    </div>
                    <div className="info-section-body">
                      <div>
                        <p>
                          Cet outil gratuit vous aide à calculer le taux de réussite et
                          le taux d'échec dans les examens et évaluations scolaires
                          avec une grande précision. Que vous soyez enseignant, élève
                          ou responsable pédagogique, cet outil vous fournit les résultats
                          dont vous avez besoin pour évaluer les performances académiques.
                        </p>
                      </div>
                      <hr />
                      <div>
                        <p><strong>Formule du taux de réussite :</strong></p>
                        <p>Taux de réussite = (nombre de reçus / nombre total) × 100%</p>
                        <p>
                          <strong>Exemple :</strong> 80 élèves, 64 ont réussi →
                          Taux = (64 ÷ 80) × 100% = 80%
                        </p>
                      </div>
                      <hr />
                      <div>
                        <p><strong>Formule du taux d'échec :</strong></p>
                        <p>Taux d'échec = (nombre d'échecs / nombre total) × 100%</p>
                        <p>ou : Taux d'échec = 100% − taux de réussite</p>
                        <p>
                          <strong>Exemple :</strong> 80 élèves, 64 reçus, 16 en échec →
                          Taux d'échec = (16 ÷ 80) × 100% = 20%
                        </p>
                      </div>
                      <hr />
                      <div>
                        <p><strong>Utilisations :</strong></p>
                        <ul>
                          <li>Calculer le taux de réussite des élèves aux examens</li>
                          <li>Évaluer les performances des classes et niveaux scolaires</li>
                          <li>Comparer les taux de réussite entre plusieurs classes</li>
                          <li>Analyser l'efficacité des méthodes pédagogiques</li>
                          <li>Préparer des rapports statistiques éducatifs</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default SuccessFailureCalculator;
